module.exports = __webpack_public_path__ + "media/packs/images/flags/TR-714fdad8126c9492a698812a753cf064.png";